<template>
    <section>
        <div v-if="!hideDetails"
            :class="['kyc-form', {'kyc-form--disabled': isFormProcessing}]"
        >
            <div class="kyc-form__title">{{ $t('kycUserIdentity.details') }}</div>

            <div class="widget widget--kyc">
                <slot name="details" />
            </div>
        </div>

        <div class="kyc-form">
            <div :class="['kyc-form__title', {'kyc-form--disabled': !isDocumentsEnabled || isFormProcessing}]">
                {{ $t('kycUserIdentity.documents') }}
            </div>

            <div class="widget widget--kyc">
                <div :class="['kyc-form__split', {'kyc-form--disabled': !isDocumentsEnabled || isFormProcessing}]">
                    <slot name="multiselect" />
                </div>

                <div :class="['kyc-form__documents', {'kyc-form--disabled': !isDocumentUploadEnabled || isFormProcessing}]">
                    <div class="kyc-form__hint">{{ $t('kycDocumentTypes.uploadDocuments') }}</div>

                    <div class="kyc-form__subtitle">{{ $t('kycDocumentTypes.uploadDocumentsSubtitle') }}</div>

                    <slot name="fileUpload" />
                </div>
            </div>
        </div>
        <div :class="['kyc-form', {'kyc-form--disabled': !isCheckboxesEnabled || isFormProcessing}]">
            <div class="kyc-form__title">{{ $t('kycUserIdentity.confirmation') }}</div>

            <div class="widget widget--kyc">
                <div class="kyc-form__hint">{{ $t('kycLevel2PhotoUploadConfirmation.confirmation') }}</div>

                <div class="kyc-form__subtitle">{{ $t('kycLevel2PhotoUploadConfirmation.description') }}</div>

                <slot name="confirmation" />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'kyc-form',
    props: {
        steps: {
            type: Array,
            default: () => ([]),
        },
        isCheckboxesEnabled: {
            type: Boolean,
            default: false,
        },
        isFormProcessing: {
            type: Boolean,
            default: false,
        },
        isDocumentUploadEnabled: {
            type: Boolean,
            default: false,
        },
        isDocumentsEnabled: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.kyc-form {
    padding: 5.4rem 2rem;
    color: $blue-charcoal-color;

    &--disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    &__title {
        font-size: 1.7rem;
        line-height: 2.7rem;
        font-weight: 700;
        color: $cyprus-color;
        padding-bottom: 1rem;

        @include min-width(lg) {
            font-size: 2rem;
        }
    }

    &__subtitle {
        padding-top: 1.4rem;
        font-size: 1.8rem;
    }

    &__hint {
        font-size: 1.1rem;
        font-weight: 700;
    }

    &__subtitle,
    &__hint {
        line-height: 1.8rem;
        width: 100%;
    }

    &__content {
        box-shadow: none;
        width: auto;
        background: $white-color;
        padding: 3.3rem 1.9rem 3rem 2.5rem;
        display: flex;
        border-radius: 1rem;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        @include min-width(lg) {
            align-items: flex-start;
            flex-direction: row;
            padding: 3.3rem 3.9rem 3.8rem 4.5rem;
        }
    }

    &__documents {
        width: 100%;
    }

    &__split {
        width: 100%;
        padding-bottom: 3.3rem;
        margin-bottom: 3.3rem;
        border-bottom: 0.3rem solid $concrete-color;
    }
}
</style>